import { Point } from "./Point";
import { ISize } from "./ISize";

// 結局Vectorとほぼ同じ情報を扱うが概念的には違うので別クラスにする.
export class Size {
  constructor(public width: number = 0, public height: number = 0) { }

  add(difference: Size) {
    return new Size(
      this.width + difference.width,
      this.height + difference.height,
    );
  }

  subtract(difference: Size) {
    return this.add(difference.reverse());
  }

  multiply(multiplier: number) {
    return new Size(
      this.width * multiplier,
      this.height * multiplier);
  }

  reverse(): Size {
    return this.multiply(-1);
  }

  floor(): Size {
    return new Size(
      Math.floor(this.width),
      Math.floor(this.height),
    );
  }

  // Point変換メソッドを提供.
  toPoint(): Point {
    return new Point(
      this.width,
      this.height
    );
  }

  static from(source: ISize | Point): Size {
    if (!source) {
      return null;
    }
    return (source instanceof Point)
      ? new Size(Math.abs(source.x), Math.abs(source.y))  // 差をサイズとする.
      : new Size(source.width, source.height);
  }

  static to(source: Size): ISize {
    if (!source) {
      return null;
    }
    return {
      width: source.width,
      height: source.height,
    };
  }

  static areEqual(source: Size, destination: Size): boolean {
    return (!source && !destination)
      || (source && destination && (source.width === destination.width) && (source.height === destination.height));
  }

  clone(): Size {
    return new Size(
      this.width,
      this.height
    );
  }
}
